import React from "react";
import { setGlobalCookie, getCookieToken } from "../../utils/globals";

import { withRouter } from "react-router-dom";
import { string } from "prop-types";
import { getUserBalance } from "../../global/getUserBalance";
import PaymentService from "../../services/PaymentService";
import { NotificationManager } from "react-notifications";
import { app_path } from "config";
import { CircularLoader } from "@plum-xoxo/admin-dsm";
class PrimerPaymentCallback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectPath: string,
      timeOutReachedForPolling: false,

      razorpay_order_id: null,
      razorpay_payment_id: null,
      razorpay_signature: null,
      company_recharge: null,
      amount: null,
      netPayableAmount: "",
      status: "",
      origin: "",
      sales_order_id: null,
    };
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidMount() {
    setTimeout(() => {
      const response = this.props.history.location.state
        ? JSON.parse(this.props.history.location.state)
        : "";
      this.setState(
        {
          razorpay_order_id: response && response.razorpay_order_id,
          razorpay_payment_id: response && response.razorpay_payment_id,
          razorpay_signature: response && response.razorpay_signature,
          company_recharge: response && response.company_recharge,
          amount: response && response.amount,
          status: response && response.status,
          origin: response && response.origin,
          sales_order_id: response && response.sales_order_id,
          netPayableAmount: response && response.netPayableAmount,

          redirectPath: response && response.redirectPage,
          order_id: response && response.order_id,
          primerToken: response && response.primerToken,
        },
        () => this.paymentUpdate()
      );
    }, 2000);
  }

  paymentUpdate = () => {
    const {
      status,
      paymentId,
      company_recharge,
      sales_order_id,
      netPayableAmount,
      currencyCode,
      primerToken,
    } = this.state;
    if (status == "success") {
      if (
        !getCookieToken("ADMIN_TRANSECTION_ID") ||
        getCookieToken("ADMIN_TRANSECTION_ID") !== sales_order_id
      ) {
        const paymentStatusOptions = {
          primer_payment_request: primerToken,
          primer_payment_response: {
            id: paymentId,
            status: "SUCCESS",
            currencyCode: currencyCode,
            orderId: sales_order_id,
            amount: netPayableAmount,
          },
          amount: parseFloat(netPayableAmount) * 100,
          company_recharge,
        };
        this.updatePayment(paymentStatusOptions);
      }
    }
  };

  updatePayment = (params) => {
    const { updateUserBalance } = this.props;
    const { company_recharge, origin, amount } = this.state;
    PaymentService.updatePrimerPayment(params).then((response) => {
      if (response && response.updatePayment) {
        if (
          !response.updatePayment.error &&
          response.updatePayment.code === "PAYMENT_COMPLETED"
        ) {
          const sales_order_id = response.updatePayment.sales_order_id;
          getUserBalance(updateUserBalance);
          setGlobalCookie("ADMIN_TRANSECTION_ID", sales_order_id);
          this.props.history.push({
            pathname:
              `/${app_path}/primer-payment-status/success/` + sales_order_id,
            state: JSON.stringify({
              origin: origin,
              order_id: sales_order_id,
              status: "success",
              amount: parseFloat(amount).toFixed(2),
              company_recharge,
              redirectPath: this.state.redirectPath,
            }),
          });
        } else {
          NotificationManager.error(response.updatePayment.msg, "Error");
        }
      } else {
        throw new Error("Error in fetching primer payment update status");
      }
    });
  };

  render() {
    return (
      <CircularLoader
        size="lg"
        vertical
        center
        content="Please do not refresh the page and wait while we are processing your
            payment..."
      />
    );
  }
}

export default withRouter(PrimerPaymentCallback);
